import React from "react";

type Props = {
  caption: string;
  gender: string | null;
};

export function GeneratingState({ caption, gender }: Props) {
  const isMale = gender === "men" || gender === "male";
  return (
    <>
      <style>{`
        @keyframes l2f-shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
        @keyframes l2f-dot { 0%, 80%, 100% { opacity: 0.3; transform: scale(0.85); } 40% { opacity: 1; transform: scale(1); } }
      `}</style>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "6px 0",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            width: 270,
            background: "#FFFFFF",
            boxShadow: "0 14px 32px rgba(0,0,0,0.18)",
            padding: "14px 14px 46px",
            borderRadius: 2,
            transform: "rotate(-1deg)",
          }}
        >
          <div
            style={{
              position: "relative",
              aspectRatio: "3 / 4",
              background: "#F4F0E8",
              borderRadius: 3,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {isMale ? (
              <svg
                viewBox="0 0 120 200"
                width={110}
                height={190}
                style={{ opacity: 0.32 }}
              >
                <ellipse cx="60" cy="26" rx="14" ry="18" fill="#888780" />
                <path d="M 22 56 Q 60 46 98 56 L 102 132 Q 60 142 18 132 Z" fill="#888780" />
                <path d="M 30 132 L 28 196 L 50 196 L 55 138 Z" fill="#888780" />
                <path d="M 65 138 L 70 196 L 92 196 L 90 132 Z" fill="#888780" />
              </svg>
            ) : (
              <svg
                viewBox="0 0 120 200"
                width={110}
                height={190}
                style={{ opacity: 0.32 }}
              >
                <ellipse cx="60" cy="28" rx="16" ry="20" fill="#888780" />
                <path d="M 30 60 Q 60 50 90 60 L 95 130 Q 60 140 25 130 Z" fill="#888780" />
                <path d="M 35 130 L 32 195 L 50 195 L 55 135 Z" fill="#888780" />
                <path d="M 65 135 L 70 195 L 88 195 L 85 130 Z" fill="#888780" />
              </svg>
            )}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(110deg, transparent 30%, rgba(255,255,255,0.6) 50%, transparent 70%)",
                backgroundSize: "200% 100%",
                animation: "l2f-shimmer 1.8s infinite",
              }}
            />
          </div>
          <p
            style={{
              fontFamily: "var(--font-display)",
              fontStyle: "italic",
              fontSize: 14,
              color: "#3C3A36",
              lineHeight: 1.35,
              textAlign: "center",
              margin: "14px 4px 0",
            }}
          >
            {caption}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 5,
            padding: "10px 0 22px",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", gap: 5 }}>
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: 999,
                  background: "#C84B2F",
                  animation: `l2f-dot 1.2s ${i * 0.2}s infinite ease-in-out`,
                  display: "inline-block",
                }}
              />
            ))}
          </div>
          <span style={{ fontSize: 12, color: "var(--l2f-muted)" }}>
            Styling your look · ~30s
          </span>
        </div>
      </div>
    </>
  );
}
